const Form057EN = {
    stepName: {
        statement: "Important Notes",
        information: "Basic Information",
        check: "Selection of Section(s)",
        sectionA: "Section A",
        sectionB: "Section B",
        sectionC: "Section C",
        sectionD: "Section D",
        sectionE: "Section E",
        certify: "Certification",
        confirmation: "Confirmation",
    },
    errorMsg: {
        date: {
            afterThisDate: "Please select a date after {{name}} {{targetDate}}",
            beforeThisDate:
                "Please select a date before {{name}} {{targetDate}}",
            laterThanDate:
                "The Date cannot be later than 31 Aug of the subject school year",
        },
        schLeave: "School Section = no. of leave days >= 1 day",
        bdgLeave: "Boarding Section = no of leave days > 2 days",
    },
    label: {
        notes: "Note",
        terms: "Statement",
        agree: "Applicants should read carefully and agree",
        data: "Notes on private data",
        read: "I have read, understood and agreed to the above terms and conditions",
        schoolInfor: "School Information",
        schoolName: "Name of School",
        schoolCode: "School Code",
        month: "Month",
        year: "Year",
        example: "For example: ",
        assuming:
            "Assuming the Qualified Period for SNG starts from 5 February to 26 May, the Number of Qualified Months should be calculated as follows:",
        claimSNG: "Application Form Selection",
        selectSNG: "Please select",
        claim: "New claim post/Revised claim",
        post: "Post",
        section: "Section",
        periodFrom: "Period From",
        periodTo: "Period To",
        leavePeriodFrom: "Leave Period From",
        leavePeriodTo: "Leave Period To",
        calendar: "No. of Calendar days",
        a: "No. of working days",
        b: "Daily Rate",
        workingDay: "No. of working days",
        dailyRate: "Daily Rate",
        c: "Number of Qualified Months",
        d: "Monthly Salary",
        e: "MPF Subsidy",
        subsidy: "MPF Subsidy",
        f: "SNG Amount",
        salaryAmount: "Salary Amount",
        totalSNG: "Total(SNG Amount)",
        attached:
            "N: New claim post /R: Revised claim(Copy of previous claim dated: ________________attached)",
        attachedTitle: "Copy of previous claim dated attached",
        remark: "Remark",
        indicate: "Please indicate the following documents",
        leaveInfor: "Information of the nurse(s) on leave",
        sngInfor: "Information for SNG",
        name: "Name",
        SPN: "SRN",
        reason: "Reason for absence",
        claimDailyRated:
            "I would like to claim daily-rated supply nurse reimbursement as follows:",
        supplyInfo: "Information of supply nurse",
        supplyName: "Name of supply nurse",
        supplyFrom: "Supply period From",
        supplyTo: "Supply period To",
        salaryTotal: "Total(Salary Amount)",
        staffNumber: "Staff Number",
        contractFrom: "Contract period From",
        contractTo: "Contract period To",
        salarySubTotal: "Sub-total(Salary Amount)",
        subsidySubTotal: "Sub-total(MPF subsidy)",
        allTotal: "Total(Salary Amount + MPF subsidy)",
        certify: "I certify that:",
        emoluments: "The emoluments have been paid",
        needCheck: "You need to select at least one option",
        number: "Please enter the number type",
        leave: "Leave Period",
        vacancyPeriod: "Vacancy Period",
        previousClaimDated: "Copy of previous claim dated",
        attachment: "Attachment",
        MPFAttachment: "Attachment for MPF Schemes",
        postNumber: "Number of post",
        dailyRateAttachment:
            "Attachment of receipts for reimbursement of daily-rated supply nurse",
        previousClaim: "Previous Claim",
        previousClaimNumber:
            "Please indicate the application number of previous claim form",
        from: "From",
        to: "To",
        MPFInformation: "MPF Supporting Information",
        postNo: "No of post",
        applicationNo: "Application Number",
        adminType: "Supervisor/School Head",
        adminName: "Name of Supervisor/School Head",
        date: "Date",
        contactPerson: "Contact Person",
        telNo: "Tel No.",
        sSDO: "SSDO",
        ssdo1: "c.c.",
        ssdo2: "SSDO(",
        ssdo3: ")",
        subventions: "To: Recurrent Subventions Section, Education Bureau",
        attn: "[Attn.: AOI(RS)]",
        certify1: "I certify that:",
        and: " and ",
        name1: "Name of ",
        name2: "",
    },
    secValue: {
        sch: "School",
        bdg: "Boarding",
    },
    previousClaimValue: {
        unchange: "Unchange previous claim",
        delete: "Delete previous claim",
        change: "Change previous claim",
    },
    supplyValue: {
        nurse: "Daily-rated supply nurse",
        trustees: "MPF Scheme trustees concerned",
    },
    sectionValue: {
        SectionA:
            "Section A SNG in exchange for vacant Nursing Officer (NO) post(s)",
        SectionB:
            "Section B SNG in exchange for vacant registered nurse (RN) post(s)",
        SectionC:
            "Section C SNG in lieu of temporary replacement for nurse(s) on approved leave",
        SectionD:
            "Section D (Daily-rated Supply Nurse Reimbursement) Employer's contribution to MPF Schemes is not required",
        SectionE:
            "Section E (Daily-rated Supply Nurse Reimbursement) Employer's contribution to MPF Schemes is required (when the continuous period of service is 60 days or more)",
    },
    leaveValue: {
        vacancy: "Leave period of less than 30 days",
        revocable: "Leave period of not less than 30 days",
    },
    vacancyValue: {
        vacancy: "Vacancy period of less than 30 days",
        revocable:
            "Revocable freezing on vacancy period of not less than 30 days",
    },
    claimValue: {
        N: "New claim post",
        R: "Revised claim",
    },
    postValue: {
        NO: "Nursing Officer",
        RN: "Registered Nurse",
        EN: "Enrolled Nurse",
    },
    adminValue: {
        supervisor: "Supervisor",
        schoolHead: "School Head",
    },
    sSDOValue: {
        0: "North District",
        1: "Kwai Chung & Tsing Yi District",
        2: "Sai Kung District",
        3: "Hong Kong East District",
        4: "Tuen Mun District",
        5: "Kowloon City District",
        6: "Kwun Tong District",
        7: "Southern District",
        8: "Yau Tsim & Mong Kok District",
        9: "Tsuen Wan District",
        10: "Sha Tin District",
        11: "Sham Shui Po District",
        12: "Tai Po District",
        13: "Wan Chai District",
        14: "Islands District",
        15: "Central & Western District",
        16: "Yuen Long District",
        17: "Wong Tai Sin District",
    },
    noteList: [
        {
            text: `Enter '√' to indicate the vacant nurse post/the nurse on leave is from school (Sch) or boarding (Bdg) section.\nIf the claim post comes from school and boarding section, please "add" an additional part and fill in the corresponding information.`,
        },
        {
            text: "The number of working days should exclude holidays of schools/boarding sections, public holidays, discretionary holidays or any days on which the nurse is not required to perform duties.",
        },
        {
            text: "Please refer to the relevant EDB circular memorandum on the prevailing daily rates of pay for supply staff in aided schools. For the purpose of (i) filling vacant Nursing Officer and Registered Nurse post of less than 30 days; or (ii) temporary replacement for Nursing Officer/Registered Nurse (including Registered Nurse with psychiatric nursing training) on approved leave of less than 30 days, the SNG is calculated based on the daily rate of the Registered Nurse. For the purpose of daily-rated supply nurse reimbursement, the reimbursement for the post of Nursing Officer/Registered Nurse is calculated based on the daily rate of the Registered Nurse.",
        },
        {
            text: "Calculate the number of qualified months from the starting date to the ending date (both dates inclusive) for SNG by adding up the following 3 elements:",
        },
        {
            text: "",
        },
        {
            text: "Employer's contribution to MPF Schemes (5% of the monthly salary capped at maximum amount stipulated under prevailing MPF regulations) will be included if the qualified period is of 60 days or more. For encashment for a period of less than 60 calendar days for freezing of vacant nurse post or temporary replacement for nurse on approved leave, and the contribution to MPF Schemes is required, please provide supporting information.",
        },
        {
            text: "Enter Staff Reference Number of the nurse on leave.",
        },
        {
            text: "Please note that granting of leave should follow the respective sessions of the Code of Aid, School Administration Guide, EDB Circular No. 1/2006, EDB Circular No. 16/2015 (applicable to paternity leave) and EDB Circular No. 16/2018 (applicable to maternity leave).",
        },
    ],
    five: [
        {
            text: "Enter the starting salary of Nursing Officer, i.e. salary amount of the MPS Point 26;",
        },
        {
            text: "Enter the mid-point salary of Registered Nurse, i.e. salary amount of the MPS Point 20;",
        },
        {
            text: "Enter the mid-point salary of Enrolled Nurse, i.e. salary amount of the MPS Point 15",
        },
    ],
    calculate: [
        {
            text: "the proportion of qualified number of days, if any, in the starting month to its total number of calendar days;",
        },
        {
            text: "number of completed calendar months, if any; and",
        },
        {
            text: "the proportion of qualified number of days, if any, in the ending month to its total number of calendar days.",
        },
    ],
    exampleList: [
        {
            text: "24 being number of days in the starting month (5 to 28 February) divided by 28 (the total number of days in February) = 0.857 months;",
        },
        {
            text: "2 being number of completed calendar months of March and April;",
        },
        {
            text: "26 being number of days in the ending month (1 to 26 May) divided by 31 (being the total number of days in May) = 0.839 months; and",
        },
        {
            text: "The Number of Qualified Months should be the sum of the above 3 elements (rounded at 3 decimals), i.e. 0.857 + 2 + 0.839 = 3.696.",
        },
    ],
    termList: [
        {
            text: "(For reimbursement of daily-rated supply nurse) the emoluments have been paid to the",
        },
        {
            text: ", relevant receipts being attached for your records;",
        },
        {
            text: "Consent has been obtained from my school's SMC/IMC and the majority of nurse(s) for freezing the nurse post(s) under Section A and Section B in the above-mentioned period in the school year;",
        },
        {
            text: "The frozen nurse post(s) claiming SNG under Section A and B arises from vacant regular post(s) during the claim period and this request for payment complies with the conditions set out for SNG applications; and",
        },
        {
            text: "No duplicate claim has been made for government subventions on account of the same leave/vacancy set out in Sections A to E.",
        },
        {
            text: "My school will refund to the Education Bureau any over-payment of grant.",
        },
    ],
    symbolList: [
        {
            text: "(i)",
        },
        {
            text: "(ii)",
        },
        {
            text: "(iii)",
        },
        {
            text: "(iv)",
        },
    ],
    // statementList: [
    //     {
    //         text: "PLEASE READ THE FOLLOWING TERMS AND CONDITIONS BEFORE USING THIS WEBSITE. BY USING THIS WEBSITE YOU AGREE TO ABIDE BY THE TERMS AND CONDITIONS SET OUT BELOW",
    //     },
    //     {
    //         text: "please submit either e-form or paper, if duplicate application has been submitted, the process would be decelerated.",
    //     },
    //     {
    //         text: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections,should be made in writing to the respective Senior School Development Officer.",
    //     },
    // ],
    importantNotes: {
        p_title: "Personal Information Collection Statement",
        p1_1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        p1_a: "processing employment-related matters;",
        p1_b: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        p1_c: "auditing;",
        p1_d: "conducting research and compiling statistics to facilitate planning of education services;",
        p1_e: "processing matters relating to the development of the education profession;",
        p1_f: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules (Cap. 279).",

        p2: "The provision of personal data by means of this form is obligatory.  Failure to provide these data may affect the processing and outcome of your application.",
        p3: "The personal data collected in this form may be disclosed to other government bureau/departments/agencies authorized to process such information for the purposes mentioned above.",
        p4: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance.  Your right of access includes the right to obtain a copy of your personal data provided in this form.  This is however subject to payment of a fee.",
        p5: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to Education Bureau.",
    },
};
export default Form057EN;
